export enum FillsGraphDataByOrderIdRequestNormalizeBy {
    ByPnc = 100,
    ByArrival = 101,
}

export default interface FillsGraphDataByOrderIdRequest {
    orderId: string;
    extendedHours: boolean;
    useSecondarySymbol: boolean;
    fallbackIndex: string;
    normalizeBy: FillsGraphDataByOrderIdRequestNormalizeBy;
    indexSymbology: string;
    useMetric: boolean;
    includeStrategyParms?: boolean;
}
